import { render, staticRenderFns } from "./OfficeSearch.vue?vue&type=template&id=42e85a34&"
import script from "./OfficeSearch.vue?vue&type=script&lang=js&"
export * from "./OfficeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/juhani/ddev/aidian-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42e85a34', component.options)
    } else {
      api.reload('42e85a34', component.options)
    }
    module.hot.accept("./OfficeSearch.vue?vue&type=template&id=42e85a34&", function () {
      api.rerender('42e85a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/OfficeSearch.vue"
export default component.exports